// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bem_a bhh_bk bhh_bl bhh_bo","SwipeLeftToClose--animating":"bem_b"};